import React from 'react';
import {
  BrowserRouter,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom';

import './css/style.css';

import Header from './component/common/header';
import Footer from './component/common/footer';
import NotFound from './component/common/404';
import Main from './component';
import Project from './component/project';

const redirectHome = () => <Redirect to="/" />;

class App extends React.Component {
  render() {
    const { RouterComponent = BrowserRouter, location, context } = this.props;

    return (
      <RouterComponent location={location} context={context}>
        <div className="d-flex flex-column min-vh-100">
          <Header />
          <div className="flex-grow-1">
            <Switch>
              <Route exact path="/" component={Main} />
              <Route exact path="/project/:name" component={Project} />
              <Route exact path="/project" component={redirectHome} />
              <Route path="*" component={NotFound} />
            </Switch>
          </div>
          <Footer />
        </div>
      </RouterComponent>
    );
  }
}

export default App;
